import { render } from "./lock-alt-solid.svg?vue&type=template&id=4e7c1cf2"
const script = {}

import exportComponent from "C:\\Users\\Asus\\Desktop\\vue\\akpa\\akpa\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__